import { createActionsHook } from 'src/lib/sweetState';

import { WorkspaceStore } from './WorkspaceStore';

export const useWorkspaceActions = createActionsHook(WorkspaceStore);
